// Блок 4: Как это работает — 4 шага timeline

const steps = [
  {
    num: '01',
    title: 'Подключите канал',
    text: 'Email, Telegram или виджет — за 5 минут, без программиста.',
    accent: 'bg-accent-brand-light text-accent-brand border-accent-brand-border',
  },
  {
    num: '02',
    title: 'AI наблюдает',
    text: 'Anima читает диалоги и учится отвечать как ваша команда.',
    accent: 'bg-accent-ai-light text-accent-ai border-accent-ai/20',
  },
  {
    num: '03',
    title: 'Проверяйте черновики',
    text: 'Shadow-режим: AI предлагает ответ, оператор решает — отправить или нет.',
    accent: 'bg-accent-success-light text-accent-success border-accent-success/20',
  },
  {
    num: '04',
    title: 'AI отвечает сам',
    text: 'Когда AI достаточно обучен — отвечает автоматически. Вы контролируете.',
    accent: 'bg-accent-secondary-light text-accent-secondary border-accent-secondary/20',
  },
] as const;

export function HowItWorksSection(): JSX.Element {
  return (
    <section className="py-20 lg:py-28 bg-surface-subtle">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <h2 className="font-heading text-3xl sm:text-4xl font-extrabold text-text-primary tracking-tight">
            Как это работает
          </h2>
          <p className="mt-4 text-text-secondary text-base sm:text-lg leading-relaxed">
            От подключения до автоматических ответов — четыре шага
          </p>
        </div>

        {/* Timeline grid */}
        <div className="relative">
          {/* Connector line — desktop */}
          <div className="hidden md:block absolute top-[2rem] left-[12.5%] right-[12.5%] h-px bg-border-strong/40" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-6">
            {steps.map((s) => (
              <div key={s.num} className="relative flex flex-col items-center text-center">
                {/* Number circle */}
                <div
                  className={`relative z-10 w-14 h-14 rounded-full border-2 ${s.accent} flex items-center justify-center text-sm font-bold font-heading ring-4 ring-surface-subtle mb-5`}
                >
                  {s.num}
                </div>
                <h3 className="font-heading text-lg font-bold text-text-primary mb-2">
                  {s.title}
                </h3>
                <p className="text-sm text-text-secondary leading-relaxed max-w-[220px]">
                  {s.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
